export const IconPerson = () => {
  return (
    <svg
      width="55"
      height="40"
      viewBox="0 0 55 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.1692 18.5909C32.3034 18.5909 36.4654 14.4292 36.4654 9.29545C36.4654 4.16171 32.3034 0 27.1692 0C22.0351 0 17.873 4.16171 17.873 9.29545C17.873 14.4292 22.0351 18.5909 27.1692 18.5909Z"
        fill="#053462"
      />
      <path
        d="M44.3397 39.5867C44.3397 31.8791 36.6645 25.5938 27.1698 25.5938C17.6751 25.5938 10 31.846 10 39.5867"
        fill="#053462"
      />
    </svg>
  );
};
